import React from 'react';
import { motion } from 'framer-motion';
import { FaBriefcase, FaLaptopCode, FaHeadset } from 'react-icons/fa';
import './Works.css';

const Works = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    }
  };

  const cardVariants = {
    hidden: { opacity: 0, scale: 0.8, rotateY: -15 },
    visible: {
      opacity: 1,
      scale: 1,
      rotateY: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    },
    hover: {
      scale: 1.05,
      y: -10,
      rotateY: 5,
      transition: {
        duration: 0.3
      }
    }
  };

  const workExperience = [
    {
      icon: <FaBriefcase />,
      title: "Software Engineering Intern",
      institution: "Campus Direct UK Pvt Ltd",
      field: "Software Development",
      period: "2025 September – Present",
      description: "Developing applications (coding, programming). Debugging and testing code. Documenting and testing new software applications."
    },
    {
      icon: <FaLaptopCode />,
      title: "Freelance Web Developer",
      institution: "Self-Employed",
      field: "Web Development",
      period: "2025 – Present",
      description: "Designing and developing custom websites for clients. Ensuring responsive design. Performance optimization and seamless user experience."
    },
    {
      icon: <FaHeadset />,
      title: "IT Helpdesk",
      institution: "Ninewells Hospital",
      field: "IT Support",
      period: "2025 July – 2025 August",
      description: "Managing daily IT Helpdesk tasks. System testing & technical support."
    }
  ];

  return (
    <section id="works" className="works">
      <div className="container">
        <motion.div
          className="works-header"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <motion.h2 className="section-title" variants={itemVariants}>
            Work Experience
          </motion.h2>
          <motion.p className="section-subtitle" variants={itemVariants}>
            My professional journey and career milestones
          </motion.p>
        </motion.div>

        <motion.div
          className="works-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {workExperience.map((work, index) => (
            <motion.div
              key={index}
              className="works-card"
              variants={cardVariants}
              whileHover="hover"
            >
              <div className="works-icon">
                {work.icon}
              </div>
              <div className="works-content">
                <h3>{work.title}</h3>
                <h4>{work.institution}</h4>
                <p className="works-field">{work.field}</p>
                <p className="works-period">{work.period}</p>
                <p className="works-description">{work.description}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Works;

